import React, { Component } from 'react';
import { connect } from 'react-redux';

// API
import * as API from '../../utils/api';

// Components
import AdminPortal from './AdminPortal';
import UsersList from '../../components/Admin/UsersList';

class AdminUsersList extends Component {
  state = {
    users: [],
    isLoading: true
  }

  componentDidMount() {
    const { currentUser } = this.props;

    API.adminUsers(currentUser)
    .then(users => this.setState({ isLoading: false, users }))
  }

  removeUser = (id) => {
    this.setState(prevState => (
      {
        users: prevState.users.filter(user => user.id !== id)
      }
    ))
  }

  render() {
    const { appName, path } = this.props
    const { isLoading, users } = this.state;

    return (
      <AdminPortal appName={appName} isLoading={isLoading} path={path}>
        <section className="admin">
          <div className="inner-wrap">
            <h4>Admin Portal</h4>
            <h1>Users</h1>
            <UsersList users={users} onDeleteClicked={this.removeUser}/>
          </div>
        </section>
      </AdminPortal>
    )
  }
}

const mapStateToProps = state => ({ currentUser: state.user });

export default connect(mapStateToProps)(AdminUsersList);



// WEBPACK FOOTER //
// ./src/screens/Admin/AdminUsersList.js